import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row my-5" }
const _hoisted_5 = { class: "col-md-10 offset-md-1 col-sm-12" }
const _hoisted_6 = { id: "landing_preview" }
const _hoisted_7 = {
  class: "mb-3",
  id: "header_preview"
}
const _hoisted_8 = ["alt", "title", "src"]
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "float-end" }
const _hoisted_11 = { id: "body_preview" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 mt-1" }
const _hoisted_14 = {
  key: 0,
  class: "text-editor-container text-center"
}
const _hoisted_15 = { class: "mt-3" }
const _hoisted_16 = { class: "my-4" }
const _hoisted_17 = {
  key: 1,
  class: "text-center header-padding"
}
const _hoisted_18 = {
  key: 2,
  class: "text-center mb-4"
}
const _hoisted_19 = {
  key: 3,
  class: "text-editor-container"
}
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = { class: "my-4 text-center" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 5,
  class: "text-center mt-4"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-12 text-center" }
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "alert alert-danger" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_editor = _resolveComponent("text-editor")!
  const _component_modal = _resolveComponent("modal")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("h1", null, "Partner Configuration")
            ])
          ], -1)),
          (!_ctx.has_error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", {
                            class: "py-3",
                            style: _normalizeStyle('background-color:' + _ctx.partner_color),
                            id: "header_subbar"
                          }, [
                            _createElementVNode("img", {
                              height: "60",
                              alt: _ctx.partner?.short_name,
                              title: _ctx.partner?.short_name,
                              src: _ctx.partner_image,
                              class: "preview_logo"
                            }, null, 8, _hoisted_8),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("button", {
                                class: "btn btn-primary text-center",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.set_logo = true;})
                              }, "Upload Logo")
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("button", {
                                  class: "btn btn-primary me-2",
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setBannerColor && _ctx.setBannerColor(...args)))
                                }, "Set Banner Color"),
                                (_ctx.partner_color != 'transparent')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn btn-primary me-2",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.clear_banner_color = true;})
                                    }, "Clear Banner Color"))
                                  : _createCommentVNode("", true)
                              ]),
                              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "clearfix" }, null, -1))
                            ])
                          ], 4)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              (_ctx.set_welcome_header)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "w-50",
                                        type: "text",
                                        maxlength: "255",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.welcome_header_update) = $event)),
                                        placeholder: "enter custom header text..."
                                      }, null, 512), [
                                        [_vModelText, _ctx.welcome_header_update]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("button", {
                                        class: "btn btn-primary",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.set_welcome_header = false))
                                      }, "Cancel"),
                                      _createElementVNode("button", {
                                        class: "btn btn-primary ms-2",
                                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitWelcomeHeader && _ctx.submitWelcomeHeader(...args)))
                                      }, "Save Welcome Header")
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (!_ctx.set_welcome_header)
                                ? (_openBlock(), _createElementBlock("h1", _hoisted_17, _toDisplayString(_ctx.partner?.welcome_header), 1))
                                : _createCommentVNode("", true),
                              (!_ctx.set_welcome_header)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("button", {
                                      class: "btn btn-primary",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.set_welcome_header = true))
                                    }, "Set Welcome Header")
                                  ]))
                                : _createCommentVNode("", true),
                              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "green-line align-center" }, null, -1)),
                              (_ctx.set_welcome_message)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _createVNode(_component_text_editor, {
                                        modelValue: _ctx.welcome_message_update,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.welcome_message_update) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                      _createElementVNode("button", {
                                        class: "btn btn-primary",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.set_welcome_message = false))
                                      }, "Cancel"),
                                      _createElementVNode("button", {
                                        class: "btn btn-primary ms-2",
                                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitWelcomeMessage && _ctx.submitWelcomeMessage(...args)))
                                      }, "Save Welcome Message")
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (!_ctx.set_welcome_message)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 4,
                                    class: "welcome-text text-center",
                                    innerHTML: _ctx.partner?.welcome_message
                                  }, null, 8, _hoisted_22))
                                : _createCommentVNode("", true),
                              (!_ctx.set_welcome_message)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("button", {
                                      class: "btn btn-primary",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.set_welcome_message = true))
                                    }, "Set Welcome Message")
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("a", {
                        href: _ctx.partner_url,
                        target: "_blank",
                        class: "btn btn-primary"
                      }, "View Active Landing Page", 8, _hoisted_26)
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.error_msg), 1)
                ])
              ])),
          _createVNode(_component_modal, {
            modelValue: _ctx.set_logo,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.set_logo) = $event)),
            "allow-close": ""
          }, {
            header: _withCtx(() => _cache[25] || (_cache[25] = [
              _createTextVNode("Upload Logo")
            ])),
            footer: _withCtx(() => [
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.set_logo = false)),
                class: "btn btn-default mx-2"
              }, "Cancel"),
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.submitLogo && _ctx.submitLogo(...args))),
                class: "btn btn-primary"
              }, "Upload Logo")
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-danger" }, [
                  _createElementVNode("strong", null, "Note: Any existing logo will be permanently removed after uploading a new logo")
                ], -1)),
                _cache[30] || (_cache[30] = _createElementVNode("p", { class: "mb-0" }, "Suggested Dimensions: max 120px height, max 300px width", -1)),
                _cache[31] || (_cache[31] = _createElementVNode("p", null, [
                  _createElementVNode("small", null, "Height will be adjusted to 60px")
                ], -1)),
                _createElementVNode("div", _hoisted_30, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", { for: "logo_file" }, "Select Logo File", -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      ref: "logo_file",
                      type: "file",
                      name: "logo_file",
                      onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.setLogoFile && _ctx.setLogoFile(...args))),
                      accept: ".jpeg, .jpg, .png, .svg"
                    }, null, 544)
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "mb-0" }, [
                    _createElementVNode("small", null, "Formats: JPEG, PNG, SVG")
                  ], -1)),
                  _cache[28] || (_cache[28] = _createElementVNode("p", null, [
                    _createElementVNode("small", null, "Max File Size: 4MB")
                  ], -1))
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_modal, {
            modelValue: _ctx.set_banner_color,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.set_banner_color) = $event)),
            "allow-close": ""
          }, {
            header: _withCtx(() => _cache[32] || (_cache[32] = [
              _createTextVNode("Set Banner Color")
            ])),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.set_banner_color = false)),
                  class: "btn btn-default mx-2"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.submitBannerColor && _ctx.submitBannerColor(...args))),
                  class: "btn btn-primary"
                }, "Save Banner Color")
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_color_picker, {
                  "is-widget": true,
                  "picker-type": "chrome",
                  "disable-history": true,
                  "disable-alpha": true,
                  pureColor: _ctx.pure_color,
                  "onUpdate:pureColor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pure_color) = $event)),
                  gradientColor: _ctx.gradient_color,
                  "onUpdate:gradientColor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.gradient_color) = $event))
                }, null, 8, ["pureColor", "gradientColor"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_modal, {
            modelValue: _ctx.clear_banner_color,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.clear_banner_color) = $event)),
            "allow-close": ""
          }, {
            header: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode("Clear Banner Color")
            ])),
            footer: _withCtx(() => [
              _createElementVNode("button", {
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.clear_banner_color = false)),
                class: "btn btn-default mx-2"
              }, "Cancel"),
              _createElementVNode("button", {
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.submitClearBannerColor && _ctx.submitClearBannerColor(...args))),
                class: "btn btn-primary"
              }, "Clear Banner")
            ]),
            default: _withCtx(() => [
              _cache[34] || (_cache[34] = _createElementVNode("div", null, [
                _createElementVNode("p", null, "Are you sure you want to clear the banner color?")
              ], -1))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}